import moment from "moment";

export const DATE_FORMAT = "DD/MM/YYYY";

// Returns formatted date string (DD/MM/YYYY) or null if value is absent/invalid
const safeDate = (val) => {
  if (!val) return null;
  // Try DD/MM/YYYY (app format) first — strict mode
  let m = moment(val, "DD/MM/YYYY", true);
  if (m.isValid()) return m.format(DATE_FORMAT);
  // Fallback: try YYYY-MM-DD (HTML date input native value)
  m = moment(val, "YYYY-MM-DD", true);
  return m.isValid() ? m.format(DATE_FORMAT) : null;
};
export const convertFormToPayload = (values, type) => {
  switch (type) {
    case "corporate":
      return {
        customer_id: values.customer_id,
        customer_type: values.customer_type,
        process_date: moment().format(DATE_FORMAT),
        customer_info: {
          process_date: moment().format(DATE_FORMAT),
          customer_type: values.customer_type,
          business_purpose_loan_flag: values.business_purpose_loan_flag,
          customers_loan_has_collateral_flag:
            values.customers_loan_has_collateral_flag,
          customer_id: values.customer_id,
          customer_name: values.customer_name,
          customer_industry: values.customer_industry,
          number_of_employees: +values.number_of_employees,
          revenue: +values.revenue,
          total_assets: +values.total_assets,
          date_of_establishment: safeDate(values.date_of_establishment),
          address: values.address,
          business_license_investment_license_number:
            values.business_license_investment_license_number,
          tax_code: values.tax_code,
          financial_statement_date: safeDate(values.financial_statement_date),
          historical_rating_rating_date: safeDate(
            values.historical_rating_rating_date,
          ),
          historical_rating_rating_id: values.historical_rating_rating_id,
          historical_rating_rm_id: values.historical_rating_rm_id,
          historical_rating_branch: values.historical_rating_branch,
          historical_rating_latest_rating:
            values.historical_rating_latest_rating,
        },
        facility_info: {
          tentative_loan_product_code: values.tentative_loan_product_code,
          tentative_loan_product: values.tentative_loan_product,
          tentative_loan_amount: +values.tentative_loan_amount,
          tentative_loan_ccy: values.tentative_loan_ccy,
          tentative_loan_tenor: values.tentative_loan_tenor,
          contract_id: values.contract_id,
          payment_frequency: values.payment_frequency,
          interest_rate_type: values.interest_rate_type,
          repricing_frequency: values.repricing_frequency,
          original_date: safeDate(values.original_date),
          payment_amount_1: +values.payment_amount_1,
          payment_amount_2: +values.payment_amount_2,
          start_date_payment_1: safeDate(values.start_date_payment_1),
          start_date_payment_2: safeDate(values.start_date_payment_2),
          total_no_of_payment_1: values.total_no_of_payment_1,
          total_no_of_payment_2: values.total_no_of_payment_2,
          collateral_type: values.collateral_type,
          collateral_type_name: values.collateral_type_name,
          collateral_id: values.collateral_id,
          collateral_currency: values.collateral_currency,
          collateral_value: +values.collateral_value,
          collateral_value_in_local_currency:
            +values.collateral_value_in_local_currency,
          collateral_senior_claim_flag: values.collateral_senior_claim_flag,
          collateral_eligible_cre_rre_flag:
            values.collateral_eligible_cre_rre_flag,
          eligible_other_irb_collat_flag: values.eligible_other_irb_collat_flag,
          eligible_irb_receivables_flag: values.eligible_irb_receivables_flag,
          eligible_guarantee_flag: values.eligible_guarantee_flag,
        },
      };
    case "retail":
    default:
      return {
        customer_id: values.customer_id,
        customer_type: values.customer_type,
        process_date: moment().format(DATE_FORMAT),
        customer_info: {
          process_date: moment().format(DATE_FORMAT),
          customer_type: values.customer_type,
          business_purpose_loan_flag: values.business_purpose_loan_flag,
          customers_loan_has_collateral_flag:
            values.customers_loan_has_collateral_flag,
          customer_id: values.customer_id,
          name: values.customer_name,
          gender: values.gender,
          date_of_birth: safeDate(values.date_of_birth),
          address: values.address,
          identification: +values.identification,
          historical_rating_rating_date: safeDate(
            values.historical_rating_rating_date,
          ),
          historical_rating_rating_id: values.historical_rating_rating_id,
          historical_rating_rm_id: values.historical_rating_rm_id,
          historical_rating_branch: values.historical_rating_branch,
          historical_rating_latest_rating:
            values.historical_rating_latest_rating,
        },
        facility_info: {
          tentative_loan_product_code: values.tentative_loan_product_code,
          tentative_loan_product: values.tentative_loan_product,
          tentative_loan_amount: +values.tentative_loan_amount,
          tentative_loan_ccy: values.tentative_loan_ccy,
          tentative_loan_tenor: values.tentative_loan_tenor,
          contract_id: values.contract_id,
          payment_frequency: values.payment_frequency,
          interest_rate_type: values.interest_rate_type,
          repricing_frequency: values.repricing_frequency,
          original_date: safeDate(values.original_date),
          payment_amount_1: +values.payment_amount_1,
          payment_amount_2: +values.payment_amount_2,
          start_date_payment_1: safeDate(values.start_date_payment_1),
          start_date_payment_2: safeDate(values.start_date_payment_2),
          total_no_of_payment_1: values.total_no_of_payment_1,
          total_no_of_payment_2: values.total_no_of_payment_2,
          collateral_type: values.collateral_type,
          collateral_type_name: values.collateral_type_name,
          collateral_id: values.collateral_id,
          collateral_currency: values.collateral_currency,
          collateral_value: +values.collateral_value,
          collateral_value_in_local_currency:
            +values.collateral_value_in_local_currency,
          collateral_senior_claim_flag: values.collateral_senior_claim_flag,
          collateral_eligible_cre_rre_flag:
            values.collateral_eligible_cre_rre_flag,
          eligible_other_irb_collat_flag: values.eligible_other_irb_collat_flag,
          eligible_irb_receivables_flag: values.eligible_irb_receivables_flag,
          eligible_guarantee_flag: values.eligible_guarantee_flag,
        },
      };
  }
};



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/helper.js